import React from 'react';
import cx from 'classnames';
import useThemeBlock from '@/hooks/useThemeBlock';
import { Section } from '@/helpers/Section';
import { LinkProps } from '@/helpers/Link/render';
import { ListProductions } from '@/components/renders';
import { ListProductionsProps } from '@/components/molecules/ListProductions/render';

import { getStyles as getDfltStyles } from '@/components/organisms/SectionOneColumn/styles.css';
import block from './block.json';

/**
 * TYPINGS
 */
type SectionCardsProductionProps = SectionOneColumnProps & {
	link?: LinkProps;
} & ListProductionsProps;

interface ForwardedSectionCardsProduction
	extends React.ForwardRefExoticComponent<
			SectionCardsProductionProps & React.RefAttributes<HTMLDivElement>
		>,
		BlockConfigs {}

/**
 * COMPONENT
 */
export const SectionCardsProduction = React.forwardRef<
	HTMLDivElement,
	SectionCardsProductionProps
>(
	(
		{
			anchor,
			className,
			title,
			productions,
			slug,
			variant: currentVariant = 'default',
			titleTag = 'h2',
			theme = {},
			getStyles = getDfltStyles,
		},
		ref
	) => {
		const { variant, blockTheme } = useThemeBlock(
			slug,
			theme,
			currentVariant
		);

		const trimmedSlug = slug.split('/');
		const modifierSlug = trimmedSlug[trimmedSlug.length - 1];

		const rootClass = cx(
			'supt-section supt-section--oneCol',
			`supt-section--${modifierSlug}`,
			getStyles(blockTheme),
			className
		);

		return (
			<Section
				id={anchor}
				className={rootClass}
				variant={variant}
				slug={slug}
				ref={ref}
			>
				<div className="supt-section__inner">
					{title && (
						<div className="supt-section__headline">
							{title && (
								<Section.Title
									text={title}
									titleTag={titleTag}
								/>
							)}
						</div>
					)}
					<div className="supt-section__content">
						<ListProductions productions={productions} />
					</div>
				</div>
			</Section>
		);
	}
) as ForwardedSectionCardsProduction;

SectionCardsProduction.slug = block.slug;
SectionCardsProduction.title = block.title;
